// src/components/Navbar/Navbar.js
import { useState, useEffect, useCallback } from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './Navbar.module.css';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Process', href: '#process' },
  { label: 'Technologies', href: '#technologies' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Contact', href: '#contact' },
];

const sectionIds = ['home', 'services', 'process', 'technologies', 'portfolio', 'contact'];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const location = useLocation();
  const isHome = location.pathname === '/';

  // Track scroll position for navbar background + active section
  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);

    // Determine active section
    let current = 'home';
    for (const id of sectionIds) {
      const el = document.getElementById(id);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= 120) {
          current = id;
        }
      }
    }
    setActiveSection(current);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.navbarScrolled : ''}`}>
      <div className={styles.logo}>
        {isHome ? (
          <a href="#home">{'<Castle Point Innovations>'}</a>
        ) : (
          <Link to="/">{'<Castle Point Innovations>'}</Link>
        )}
      </div>
      <button
        className={`${styles.menuToggle} ${menuOpen ? styles.menuToggleOpen : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation"
      >
        <span className={styles.menuBar} />
        <span className={styles.menuBar} />
        <span className={styles.menuBar} />
      </button>
      <ul className={`${styles.navLinks} ${menuOpen ? styles.navLinksOpen : ''}`}>
        {navLinks.map((link, i) => (
          <li key={link.label} style={{ '--nav-index': i }}>
            <a
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className={activeSection === link.href.slice(1) ? styles.activeLink : ''}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Navbar;
